import { connect } from 'react-redux';
import {
  fetchTranslatorLanguages,
  detectLanguage,
} from './translation-modal-actions';
import TranslationModal from '../components/translation-modal';

const mapStateToProps = state => ({
  locale: state.languageProvider.locale,
  translatorLanguages: state.translator.translatorLanguages,
  isLoading: state.translator.isLoading,
  error: state.translator.error,
});

const mapDispatchToProps = {
  fetchTranslatorLanguages,
  detectLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(TranslationModal);
